goog.require('el8.app.setup');
goog.require('el8.appanalytics.dialog.billingReportCSV');
goog.require('el8.data.practiceUsers');
goog.require('el8.service.infoField');
goog.require('el8.service.tooltip');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.addDatepicker');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.amplitude.billingHelpers');
goog.require('el8.util.datecompare');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.appbilling = {
    fromDateInfoField: null,
    toDateInfoField: null
};

el8.main.appbilling._getParams = function() {
    var from_str = this.fromDateInfoField.getVal() || null;
    var to_str = this.toDateInfoField.getVal() || null;
    var physicianIdorKey = $('#billing-report-physician-select').val() || null;
    var key = null;
    var physicianId = null;

    if (physicianIdorKey === 'all') {
        key = 'all';
    } else if (physicianIdorKey === 'unassigned') {
        key = 'unassigned';
    } else {
        physicianId = physicianIdorKey;
    }

    return {
        'physicianId': physicianId,
        'key': key,
        'from': from_str ? from_str.replace(/\//g, "-") : null,
        'to': to_str ? to_str.replace(/\//g, "-") : null
    };
};

el8.main.appbilling.init = function(spec) {
    var that = this;
    var billedRow = $('#billed-notes');

    spec['layout'] = {innerContainerSelector: '#billing-container'};
    el8.app.setup(spec);

    el8.data.practiceUsers.load();

    el8React.configureStore(spec.data);
    el8React.renderFindChartHeaderButton('react-chartnav');
    el8React.renderSupportDialog('page-billing-react-support-dialog-container')


    function moveToBilled(row) {
        row.remove();

        var div = row.find('.reportBillRefNumberWrap');
        div.removeClass('reportBillRefNumberWrap');
        div.addClass('reportBillRefNumber');

        var input = div.children(':first');
        input.prop('disabled', true);

        div.next().remove();

        var ourDate = Date.parse($(row.children()[0]).text());
        var putIt = false;
        var afterRow = billedRow;
        // Gotta put it in the right place.. document date sorted descending.
        $('tr.billedRow').each(function(i, elt) {
            if (putIt) {
                return;
            }

            var dateRow = $($(elt).children()[0]);
            var rowDate = Date.parse(dateRow.text());

            if (rowDate <= ourDate) {
                row.insertBefore(elt);
                putIt = true;
            }
            afterRow = elt;
        });

        row.attr('class', 'reportBillingEntry billedRow');
        if (!putIt) {
            row.insertAfter(afterRow);
        }
    }

    // Each row contains a form with submit for the ref number
    $('form').each(function(index, value){
        var form = $(this);
        var row = form.parents('tr');

        $(value).submit(function() {
            $(this).ajaxSubmit({
                success: function(data) {
                    // Don't do this if already billed and this is a ref number update.
                    //
                    // This is going to be inconsistent in certain cases since this
                    // row's data is not actually updated. But that's basically impossible
                    // without a complete rewrite of the FE. Not changing since a reload
                    // will fix any inconsistency
                    if (!row.first().hasClass('billedRow')) {
                        moveToBilled(row)
                    }
                    el8.appservice.notifier.notify('Reference number updated in Elation', 2000)
                }
            });
            return false;
        });

        // Add popover to submit button
        el8.service.tooltip.create({
            anchor: form.children('button').first(),
            text: "Add or Update a Billing Reference Number<br>should only be used on charges you are<br>NOT sending to PMS",
            placement: 'right',
            theme: 'gray',
        });
    });

    // setup infoFields and datePickers
    this.fromDateInfoField = el8.service.infoField.addInfoField({
        field: $('#billing-report-date-from')
    });

    el8.uiwidget.addDatepicker(this.fromDateInfoField, {
        maxDate: el8.service.tz.today()
    });
    this.fromDateInfoField.setVal(el8.service.tz.todayPlusDays(-7).asString());

    this.toDateInfoField = el8.service.infoField.addInfoField({
        field: $('#billing-report-date-to')
    });
    el8.uiwidget.addDatepicker(this.toDateInfoField, {
        maxDate: el8.service.tz.today()
    });
    this.toDateInfoField.setVal(el8.service.tz.today().asString());

    var from_param = el8.util.getUrlParam('from');
    var to_param = el8.util.getUrlParam('to');

    if (from_param) {
        var cleaner = from_param.replace(/-/g,'/');
        this.fromDateInfoField.setVal(el8.service.tz.newTzDate(cleaner).asString());
    }

    if (to_param) {
        var cleaner = to_param.replace(/-/g,'/');
        this.toDateInfoField.setVal(el8.service.tz.newTzDate(cleaner).asString());
    }

    // Is the date range > 7 days? If so, hide the print link and show a download CSV link
    if (el8.util.datecompare.daysBetween(el8.service.tz.newTzDate(from_param),
                                         el8.service.tz.newTzDate(to_param)) > 7) {
        $('.billing-report-print-section').hide();
        $('.billing-report-print-csv-section').show();
    } else {
        $('.billing-report-print-csv-section').hide();
    }

    //
    // triggers
    $('#billing-report-fetch-btn').click(function(e) {
        var params = that._getParams();
        window.location = el8.service.urls.get('billingReport',
                                               [params['physicianId'],
                                                params['key'],
                                                params['from'],
                                                params['to']]);
    });

    $(document).on('click', '.print-trigger',  function(e) {

        var printPath = window.location.pathname + 'printout/' + window.location.search;
        window.open(printPath);

    }).on('click', '.print-invoice-trigger',  function() {
        var $this = $(this);
        var patientId = $this.data('patient');
        var noteId = $this.data('note');
        var type = $this.data('type');
        var printPath = '';

        if (type === 'icd10') {
            printPath = el8.service.urls.get('printPatientInvoice', [patientId, noteId, true, true, false]);
        } else {
            printPath = el8.service.urls.get('printPatientInvoice', [patientId, noteId, true, false, true]);
        }
        window.open(printPath);

    }).on('click', '.change-copay-and-note-trigger',  function() {
        var $this = $(this);
        var patientId = $this.data('patient');
        var noteId = $this.data('note');

        var row = $('.queuedRow', '#billing-container').filter('[data-id=' + noteId +']')[0];
        var $row = $(row);
        var inp = $('input', $row);

        var copay = 0.0;
        if (inp.val() !== '') {
            copay = inp.val();
        } else {
            inp.val('0.0'); // update input to 0.0 if cleared
        }

        var ta = $('textarea', $row);
        var note = ta.val();
        var confirmElt = $('.confirm', $row);

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('updateCopayAndNote', [patientId, noteId]),
            data: JSON.stringify({copay: copay, note: note}),
            success: function(data) {
                confirmElt.text('Saved');
                $.el8_setTimeout(function() { confirmElt.text(''); }, 2*1000);
            }
        });

    }).on('click', '.send-queued-bills',  function(event) {
        var params = el8.main.appbilling._getParams();
        var $button = $(event.currentTarget);
        $button.prop('disabled', true);

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('sendQueuedBills'),
            data: JSON.stringify({
                'physician_id_or_key':  params['physicianId'] ? params['physicianId'] : params['key'],
                'from': params['from'],
                'to': params['to']
            }),
            success: function(data) {
                $button.prop('disabled', false);
                el8.uiwidget.confirm('All queued bills sent. Reload?',
                                     function () { window.location.reload(); },
                                     null,
                                     null);
            },
            error: function() {
                $button.prop('disabled', false);
            }
        });

      }).on('click', '.send-individual-bill-to-pms',  function(event) {
        var params = el8.main.appbilling._getParams();
        var $button = $(event.currentTarget);
        $button.html('Sending');
        $button.prop('disabled', true);
        var $this = $(this)
        var noteId = $this.data('note')
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('sendQueuedBills'),
            data: JSON.stringify({
                'physician_id_or_key':  params['physicianId'] ? params['physicianId'] : params['key'],
                'from': params['from'],
                'to': params['to'],
                'visit_note_ids': [noteId]
            }),
            success: function(data) {
              $button.html('Sent');
              el8.appservice.notifier.notify('Bill sent')
          },
            error: function() {
                $button.prop('disabled', false);
                $button.html('Send to PMS');
                el8.appservice.notifier.notify('An error occured. Please try again.')
            }
        });

      }).on('click', '.resend-trigger',  function(e) {
        var resendPath = window.location.pathname + 'resend/' + window.location.search;
        window.open(resendPath);

    })
    .on('click', '.download-csv-trigger',  function() {
        var params = that._getParams();
        el8.appanalytics.dialog.billingReportCSV.show(params['physicianId'],
                                                      params['key'],
                                                      params['from'],
                                                      params['to']);
    })
    .on('click', '#billing-system-link', function() {
        el8.util.amplitude.logOpenBillingSystem();
    });

};
